export enum RefundStatusEnum {
    RECUESTES = 1,
    REFUNDED = 2,
    REJECTED = 3,
}
export const RefundStatus: {
    name: string
    value: string
    count: number
    showCount: boolean
}[] = []

Object.keys(RefundStatusEnum).forEach((value: string) =>
    isNaN(+value)
        ? RefundStatus.push({
            name: value,
            value: RefundStatusEnum[value as any],
            count: 0,
            showCount: false,
        })
        : null
)